"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _linkFieldSrc = require("../../lib/linkFieldSrc");
var _reactBootstrap = require("react-bootstrap");
var _siteHelper = require("../../lib/siteHelper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Renders the MM footer
 *
 * @param {object} props sitecore fields Properties used to render the footer
 *
 * @returns {React.ReactElement} A footer element
 */
function FooterSocialShare(props) {
  var socialShare = props.fields.NavSetting.fields.SocialShare;
  if (!socialShare || !socialShare.fields) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    className: "social-share"
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "list-inline"
  }, socialShare.fields.SocialShareList.map(social => {
    var {
      linkUrl,
      linkTarget,
      linkAlt
    } = (0, _linkFieldSrc.linkFieldSrc)(social.fields.TargetLink.value);
    linkUrl = (0, _siteHelper.getSocialShareUrl)({
      linkUrl: linkUrl,
      pagePath: props.pagePath,
      metaTitle: props.fields.MetaTitle.value,
      metaDescription: props.fields.MetaDescription.value,
      appEnv: props.env
    });
    return /*#__PURE__*/_react.default.createElement("li", {
      key: social.id,
      className: "list-inline-item"
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: linkUrl,
      target: linkTarget,
      rel: "noopener noreferrer",
      "aria-label": linkAlt
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: social.fields.IconName.value
    })));
  })))));
}
;
var _default = exports.default = FooterSocialShare;